export default __webpack_public_path__ + "static/media/sent.86dcc6ee.png";